<template>
  <div class="dropdown-template">
    <p class="heading">Choose a Payment type:</p>

    <div class="dropdown"
      @click="dropDownVisible = !dropDownVisible"
      label="Choose a Payment type"
      v-click-outside="hide">

      <div :class="{ active : dropDownVisible }" class="title">
        <span>{{getActiveCategory.name}}</span>
        <img class="drop-down-arrow" :src="DropDownArrow" alt="" />
      </div>

      <transition name="scale-in">
        <div v-if="dropDownVisible" class="content" :class="{ active : dropDownVisible }">
          <div v-for="(category, index) in getCategories" :key='index'>
            <p class="category" @click="setActiveCategory(category)">{{category.name}}</p>

            <div v-if="category.subcategories">
              <div v-for="(subcategory, index) in category.subcategories" :key='index'>
                <p class="subcategory" @click="setActiveCategory(subcategory)">{{subcategory.name}}</p>
              </div>
            </div>

            <hr>
          </div>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import DropDownArrow from '../assets/images/dropdown-arrow.svg'
  import ClickOutside from 'vue-click-outside'

  export default {
    data () {
      return {
        dropDownVisible: false,
        DropDownArrow
      }
    },
    created () {
      // Set initial sorting
      this.sortLocations(this.getActiveCategory.sort)
    },
    computed: {
      ...mapGetters(['getCategories', 'getActiveCategory'])
    },
    methods: {
      ...mapMutations(['setActiveCategory', 'sortLocations']),
      hide () {
        this.dropDownVisible = false
      }
    },
    watch: {
      getActiveCategory (newVal, oldVal) {
        this.sortLocations(newVal.sort)
      }
    },
    directives: {
     ClickOutside
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  .scale-in-enter-active,
  .scale-in-leave-active {
    transition: all $animation-timing-fn;
    transform-origin: 0 0;
  }
  .scale-in-enter,
  .scale-in-leave-to {
    transform: rotateX(90deg);
    opacity: 0;
  }

  .heading {
    font-family: $ff-effra-regular;
    text-transform: uppercase;
    font-size: 15px;
    color: $brand-secondary;
    text-align: center;
    font-weight: bold;
  }

  .dropdown-template {
    display: block;
    width: 80%;
    margin: 0 auto 30px;
  }

  .dropdown {
    color: $brand-secondary;
    position: relative;
    font-size: 17px;
    border-radius: 2px;
    cursor: pointer;
    font-family: $ff-effra-regular;
    margin: 0 auto;

    &:focus {
      outline: 0;
    }
  }

  .title {
    background: $brand-white;
    padding: 10px;
    border: $border-primary;

    .drop-down-arrow {
      right: $row-height/2;
      height: 10px;
      top: 15px;
      position: absolute;
      transition: all $animation-timing-fn;
      transform: rotate(90deg);
    }

    &.active {
      .drop-down-arrow {
        transform: rotate(-90deg);
      }
    }
  }

  .content {
    background: $brand-white;
    z-index: 10;
    position: absolute;
    width: 100%;
    right: 0px;
    top: calc(100% - 1px);
    border: $border-primary;
    border-top: 0;

    hr {
      width: 100%;
      border: 0;
      border-bottom: $border-secondary;
    }

    :last-child > hr {
      display: none;
    }
  }

  .category {
    padding: 10px 15px;
    margin: 0;
  }

  .subcategory {
    padding: 10px 30px;
    margin: 0;
  }

  .category:hover,
  .subcategory:hover {
    background: #E6F5FB;
  }
</style>



// WEBPACK FOOTER //
// src/components/CategoryDropdown.vue